import FingerprintJS from '@fingerprintjs/fingerprintjs';
const fpPromise = FingerprintJS.load()

import BrowserDetector from 'browser-dtector';


let vId
fpPromise
    .then(fp => fp.get())
    .then(result => {
        const visitorId = result.visitorId
        vId = visitorId
        document.getElementById('user_fingerprint').value = visitorId
        const detector = new BrowserDetector(window.navigator.userAgent);
        let info = detector.parseUserAgent();
        document.getElementById('user_browser_name').value = info.name
        document.getElementById('user_browser_platform').value = info.platform
        document.getElementById('user_browser_version').value = info.version

        let user_invite_token_element = document.getElementById('user_invite_token')
        let user_invite_token = null;
        if(user_invite_token_element){
          user_invite_token = user_invite_token_element.value
        }


        // Constructing the Google URL
        let proceed_to_google_url = "/login_google?";
        proceed_to_google_url += "fingerprint=" + encodeURIComponent(vId);
        proceed_to_google_url += "&browser_name=" + encodeURIComponent(info.name);
        proceed_to_google_url += "&browser_platform=" + encodeURIComponent(info.platform);
        proceed_to_google_url += "&browser_version=" + encodeURIComponent(info.version);
        if(user_invite_token){
           proceed_to_google_url += "&invite_token=" + encodeURIComponent(user_invite_token);
        }

        console.log(proceed_to_google_url)

        document.getElementsByName('proceed_to')[0].value = proceed_to_google_url
    })